import React from "react";
import IconEnviado from "../componentsStyled/icon/Iconenviado";
import { Box, Button, Modal } from "@mui/material";

interface ModalEnvioProps {
  isOpen: boolean;
  children?: React.ReactNode;
  onRequestClose: () => void;
}

const ModalEnvio: React.FC<ModalEnvioProps> = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onRequestClose}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: 1,
        width: 300,
        height: "fit-content",
        bgcolor: "#fff",
        boxShadow: 24,
        "& .MuiBackdrop-root": { backgroundColor: "transparent" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        borderRadius: 10,
      }}>
      <Box>
        <IconEnviado width={60} />
        <Box marginY={2}>
          <p>
            <strong style={{ color: "#008000" }}>Reembolso em Progresso!</strong>
          </p>
        </Box>

        <Box marginY={2}>
          <p>Sua solicitação de Devolução foi aprovada! Já estamos processando a sua opção de reembolso.</p>
        </Box>

        <Button onClick={onRequestClose}>Voltar</Button>
      </Box>
    </Modal>
  );
};

export default ModalEnvio;
